module.exports = __webpack_public_path__ + "media/src/images/squarespace-01feed5f91b06963c10e8d99e60d47cb.png";